import cookies from 'js-cookie'

export enum CookieName {
  UniversalLoginFlow = 'universal-login-flow',
  AnalyticsGACID = '_sg_analytics_ga_cid',
  AnalyticsGASID = '_sg_analytics_ga_sid',
  AnalyticsCountry = '_sg_analytics_country',
}

export const Cookies = cookies.withAttributes({
  secure: ['test', 'production'].includes(process.env.NODE_ENV),
  sameSite: 'strict',
  path: '/',
})
